import YouTubePlayer from 'youtube-player';
import Component from '../../../scripts/utilities/component';

class VideoItem extends Component {
    componentDidMount() {
        this.playButton = [...this.root.querySelectorAll('[data-ref="play-button"]')];

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.playButton.forEach((link) => {
            link.addEventListener('click', this.handleClick.bind(this), true);
        });
    }

    handleClick(e) {
        e.preventDefault();
        const videoID = this.root.getAttribute('data-video-id');
        const isLoaded = this.root.classList.contains('is--loaded');
        const isPlaying = this.root.classList.contains('is--playing');

        if (isLoaded && !isPlaying) {
            this.player.playVideo();
        } else if (isLoaded && isPlaying) {
            this.player.pauseVideo();
        }

        if (!this.player) {
            this.player = new YouTubePlayer(`${videoID}`, {
                videoId: `${videoID}`,
                playerVars: {
                    autoplay: 1,
                    disablekb: 0,
                    enablejsapi: 1,
                    loop: 0,
                    modestbranding: 1,
                    playsinline: 0,
                    rel: 0,
                    showinfo: 0,
                    color: 'white',
                    iv_load_policy: 3
                }
            });

            this.player.playVideo();

            this.root.classList.add('is--loading');
            this.root.classList.add('is--loaded');
        }

        this.player.on('stateChange', (event) => {
            // Stop || Pause
            if (event.data === 0 || event.data === 2) {
                this.root.classList.remove('is--playing');
            }

            // Play
            if (event.data === 1) {
                this.root.classList.remove('is--loading');
                this.root.classList.add('is--playing');
            }
        });
    }
}

export default VideoItem;



// WEBPACK FOOTER //
// ./components/eng-ms-video-item/scripts/video-item.js